import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'zip_code_protection-retailer_exclusivity_post_commitment_info-click';
/**
 * Triggered when user click the post commitment exclusivity info badge on different surface area
 */ export function trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoClick(agreement_token, origin2) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            agreement_token: agreement_token,
            origin2: origin2
        }
    });
}
